var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog__categories-wrapper" }, [
    _c(
      "div",
      { staticClass: "blog__categories" },
      [
        _c(
          "swiper",
          {
            ref: "blogCategoriesCarousel",
            staticClass: "blog__categories-carousel",
            class: { "no-swiping": _vm.$mq !== "mobile" },
            attrs: { options: _vm.swiperOptionsBlog }
          },
          _vm._l(_vm.categoryLinks.blogs, function(blog) {
            return _c("swiper-slide", { key: blog.blogTitle }, [
              _c(
                "a",
                {
                  staticClass: "button button--primary",
                  class: {
                    "button--active":
                      _vm.categoryLinks.currentBlog === blog.blogTitle
                  },
                  attrs: { href: blog.blogUrl }
                },
                [
                  _c("span", { staticClass: "button__content" }, [
                    _vm._v(_vm._s(blog.blogTitle))
                  ])
                ]
              )
            ])
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }